import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin, Building2, ShieldCheck } from "lucide-react";
import { SOLUTIONS } from "@/data/content";
import { Logo } from "./Header";

const BADGES = [
  "140M+ Verified Global Business Contacts",
  "15,000+ Tracked Tech Install Bases",
  "100% GDPR, CCPA & CASL Compliant",
  "Triple-Verification Lead Standard",
];

const COMPANY = [
  { label: "About Vyacomm Media", to: "/about-us" },
  { label: "Our Methodology", to: "/quality-compliance" },
  { label: "Data Verification Standards", to: "/quality-compliance" },
  { label: "Global Privacy & Security", to: "/quality-compliance" },
  { label: "Agency Partnership Program", to: "/contact-us" },
  { label: "Careers", to: "/contact-us" },
];

const RESOURCES = [
  { label: "Industry Insights", to: "/about-us" },
  { label: "B2B Benchmarks", to: "/solutions" },
  { label: "Privacy Policy", to: "/quality-compliance" },
  { label: "Terms of Engagement", to: "/contact-us" },
  { label: "CCPA/GDPR Compliance Statement", to: "/quality-compliance" },
  { label: "Cookie Preferences", to: "/" },
];

export const Footer = () => (
  <footer className="grain relative overflow-hidden bg-[#071222] text-slate-300" data-testid="global-footer">
    <div className="relative z-10 mx-auto max-w-[1808px] px-5 pb-10 pt-16 sm:px-8 lg:px-12 2xl:px-14">
      <div className="flex flex-wrap gap-3 border-b border-white/10 pb-10">
        {BADGES.map((b) => (
          <span
            key={b}
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 font-mono2 text-[10px] tracking-[0.16em] text-slate-300"
          >
            <ShieldCheck className="h-3.5 w-3.5 text-flame" />
            {b.toUpperCase()}
          </span>
        ))}
      </div>

      <div className="grid gap-12 py-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Vyacomm Media is an elite global B2B demand generation partner and technology media publisher. We empower
            leading enterprise tech brands and top-tier media agencies with precision-targeted audience reach,
            high-velocity lead funnels, and verified pipeline growth across 90+ markets.
          </p>
          <Link
            to="/contact-us"
            data-testid="footer-cta-link"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-cobaltlight transition-colors hover:text-white"
          >
            Start a conversation <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-mono2 text-[11px] tracking-[0.24em] text-slate-500">SOLUTIONS</h4>
          <ul className="mt-5 space-y-3">
            {SOLUTIONS.map((s) => (
              <li key={s.id}>
                <Link to={`/solutions/${s.id}`} className="text-sm text-slate-400 transition-colors hover:text-white">
                  {s.title}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/services/email-marketing" className="text-sm text-slate-400 transition-colors hover:text-white">
                Email Marketing & Deliverability
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono2 text-[11px] tracking-[0.24em] text-slate-500">COMPANY</h4>
          <ul className="mt-5 space-y-3">
            {COMPANY.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-slate-400 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono2 text-[11px] tracking-[0.24em] text-slate-500">RESOURCES & LEGAL</h4>
          <ul className="mt-5 space-y-3">
            {RESOURCES.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-slate-400 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="grid gap-8 rounded-2xl border border-white/10 bg-white/[0.03] p-7 sm:grid-cols-2 lg:grid-cols-4" data-testid="footer-contact-bar">
        {[
          { icon: MapPin, t: "Address", lines: ["30 N. Gould St. Ste R Sheridan,", "WY 82801"] },
          { icon: Mail, t: "Email", lines: ["sales@vyacomm-media.com"] },
          { icon: Phone, t: "Phone", lines: ["+1 307 2180235"] },
          { icon: Building2, t: "Corporate Hub", lines: ["India, US"] },
        ].map((c) => (
          <div key={c.t} className="flex flex-col gap-3" data-testid={`footer-contact-${c.t.toLowerCase().replace(/\s+/g, "-")}`}>
            <c.icon className="h-5 w-5 text-cobaltlight" />
            <div>
              <p className="text-sm font-semibold text-white">{c.t}</p>
              {c.lines.map((l) => (
                <p key={l} className="mt-1 text-[13px] leading-relaxed text-slate-400">
                  {l}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>

      <p className="mt-10 border-t border-white/10 pt-6 text-xs text-slate-500">
        © 2026 Vyacomm Media LLC. All Rights Reserved. All brand trademarks and registered service marks cited belong to
        their respective copyright owners.
      </p>
    </div>
  </footer>
);
